module.exports = __webpack_public_path__ + "img/foxdown_slider_2.c0575b70.png";